import { Role } from '../../../../enums/Role';
import { GetPermissionFn } from '../types';

export const getViewAdministrationPermission: GetPermissionFn = ({
  isWorkspaceOwner,
  hasRole
}) => {
  if (hasRole(Role.admin) || isWorkspaceOwner) {
    return { canView: true, canEdit: true };
  }
  return { canView: true, canEdit: false };
};
